import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Modal,
  Divider,
  Typography,
  Checkbox,
  Button
} from 'antd';
import EditWrapper from '../../components/EditWrapper';

import { colors } from '../Construction/utils/convertCalculationResponse';
import { colors as colorsVariables } from '../../utils/variables.styles';

import {
  Content,
  StyledTitle,
  SelectedWrapper
} from '../../components/SelectEdit/SelectEdit.styles';

import SelectEdit from '../../components/SelectEdit';
import selector from './colorEditor.selector';
import { setSelected, setAllColors } from '../Construction/construction.reducer';

import { infoShape } from '../../types/info.types';

import {
  ModalContainer,
  ColorContainer,
  ColorWrapper,
  Color,
  ItemContainer,
  ColorName
} from './colorEditor.styles';

const { Title } = Typography;

/** Kolejność typów bram */
const ALL_GATE_TYPES_ORDER = [
  'swing_gate',
  'double_leaf_gate',
  'sectional_gate',
  'roller_gate'
];

/** Fallback labelki typów bram */
const GATE_TYPE_FALLBACK_LABELS = {
  swing_gate: 'Brama uchylna',
  double_leaf_gate: 'Brama dwuskrzydłowa',
  sectional_gate: 'Brama segmentowa',
  roller_gate: 'Brama rolowana'
};

/** Mapowanie: typ bramy -> klucz w reducerze (NOWE NAZWY) */
const GATE_COLOR_KEY_BY_TYPE = {
  swing_gate: 'gates_swing_color',
  double_leaf_gate: 'gates_double_leaf_color',
  sectional_gate: 'gates_sectional_color',
  roller_gate: 'gates_roller_color'
};

/** Reverse map: klucz -> typ (żeby łatwo odczytać z gatesColorSelectedByType) */
const GATE_COLOR_TYPE_BY_KEY = Object.keys(GATE_COLOR_KEY_BY_TYPE).reduce((acc, type) => {
  const key = GATE_COLOR_KEY_BY_TYPE[type];
  acc[key] = type;
  return acc;
}, {});

/** Stała etykieta bazowa */
const GATES_LABEL_BASE = 'Brama';

class ColorEditor extends React.Component {
  static propTypes = {
    loaded: PropTypes.bool.isRequired,
    setAllColors: PropTypes.func.isRequired,
    setSelected: PropTypes.func.isRequired,
    available: PropTypes.object,
    colors: PropTypes.arrayOf(PropTypes.object),

    doors_back_color_info: infoShape,
    doors_back_color_selected: PropTypes.number,
    doors_front_color_info: infoShape,
    doors_front_color_selected: PropTypes.number,
    doors_left_color_info: infoShape,
    doors_left_color_selected: PropTypes.number,
    doors_right_color_info: infoShape,
    doors_right_color_selected: PropTypes.number,

    gates_color_info: infoShape,
    gates_color_selected: PropTypes.number,

    roof_color_info: infoShape,
    roof_color_selected: PropTypes.number,
    roofing_color_info: infoShape,
    roofing_color_selected: PropTypes.number,
    tooling_color_info: infoShape,
    tooling_color_selected: PropTypes.number,
    roof_tooling_color_info: infoShape,
    roof_tooling_color_selected: PropTypes.number,
    gutters_color_info: infoShape,
    gutters_color_selected: PropTypes.number,
    walls_color_info: infoShape,
    walls_color_selected: PropTypes.number,

    gateTypesPresent: PropTypes.arrayOf(PropTypes.string),

    gatesColorSelectedByType: PropTypes.shape({
      swing_gate: PropTypes.number,
      double_leaf_gate: PropTypes.number,
      sectional_gate: PropTypes.number,
      roller_gate: PropTypes.number
    }),

    translationsData: PropTypes.object,

    sheet_thickness_selected: PropTypes.number,
    sheet_thickness_available: PropTypes.array
  }

  static defaultProps = {
    available: { matt: [], smooth: [], wooden: [] },
    colors: [],
    roof_color_info: null,
    roof_color_selected: null,
    tooling_color_info: null,
    tooling_color_selected: null,
    gutters_color_info: null,
    gutters_color_selected: null,
    roof_tooling_color_info: null,
    roof_tooling_color_selected: null,
    roofing_color_info: null,
    roofing_color_selected: null,
    walls_color_info: null,
    walls_color_selected: null,
    gates_color_info: null,
    gates_color_selected: null,
    doors_front_color_info: null,
    doors_front_color_selected: null,
    doors_back_color_info: null,
    doors_back_color_selected: null,
    doors_left_color_info: null,
    doors_left_color_selected: null,
    doors_right_color_info: null,
    doors_right_color_selected: null,

    gateTypesPresent: [],
    gatesColorSelectedByType: {
      swing_gate: null,
      double_leaf_gate: null,
      sectional_gate: null,
      roller_gate: null
    },

    translationsData: null,
    sheet_thickness_selected: null,
    sheet_thickness_available: []
  }

  state = {
    modalVisible: false,
    info: null,
    name: null,           // np. "walls_color" albo "gates_swing_color"
    activeGateType: null, // tylko dla bram
    toAll: false,
    selected: null,
    isWooden: false
  }

  componentDidMount() {
    this.ensureGateColorDefaults();
  }

  componentDidUpdate(prevProps) {
    // jeśli zmieniły się typy bram i aktualnie otwarty modal jest dla bram typu, którego już nie ma - zamknij
    if (prevProps.gateTypesPresent !== this.props.gateTypesPresent) {
      const visible = this.getVisibleGateTypes();
      const isGateKey = !!(this.state.name && GATE_COLOR_TYPE_BY_KEY[this.state.name]);
      if (this.state.modalVisible && isGateKey) {
        if (!this.state.activeGateType || !visible.includes(this.state.activeGateType)) {
          this.closeModal();
        }
      }
    }

    // pilnuj defaultów (pierwszy smooth)
    if (
      prevProps.loaded !== this.props.loaded ||
      prevProps.available?.smooth !== this.props.available?.smooth ||
      prevProps.gateTypesPresent !== this.props.gateTypesPresent ||
      prevProps.gatesColorSelectedByType !== this.props.gatesColorSelectedByType ||
      prevProps.gates_color_selected !== this.props.gates_color_selected
    ) {
      this.ensureGateColorDefaults();
    }
  }

  getDefaultSmoothId = () => {
    return this.props.available?.smooth?.[0]?.id ?? null;
  };

  ensureGateColorDefaults = () => {
    if (!this.props.loaded) return;

    const defaultSmoothId = this.getDefaultSmoothId();
    if (!defaultSmoothId) return;

    const visibleGateTypes = this.getVisibleGateTypes();

    // jeśli mamy bramy per-typ -> ustaw default dla każdego typu (NOWE KLUCZE)
    if (visibleGateTypes.length > 0) {
      visibleGateTypes.forEach((gateType) => {
        const current = this.props.gatesColorSelectedByType?.[gateType] ?? null;
        const key = GATE_COLOR_KEY_BY_TYPE[gateType];

        if (key && current == null) {
          this.props.setSelected(key, defaultSmoothId);
        }
      });
      return;
    }

    // fallback: jedna brama (stare gates_color) -> ustaw default
    const currentSingle = this.props.gates_color_selected ?? null;
    if (currentSingle == null) {
      this.props.setSelected('gates_color', defaultSmoothId);
    }
  };

  getVisibleGateTypes = () => {
    const present = new Set(this.props.gateTypesPresent || []);
    if (present.size === 0) return [];
    return ALL_GATE_TYPES_ORDER.filter((t) => present.has(t));
  };

  getGateTypeLabel = (gateType) => {
    return (this.props.translationsData && (
      (this.props.translationsData.gate_types && this.props.translationsData.gate_types[gateType]) ||
      this.props.translationsData[`gate_type_${gateType}`]
    )) || GATE_TYPE_FALLBACK_LABELS[gateType] || gateType;
  };

  // RAW (bez fallbacków)
  getSelectedFromPropsRaw = (name) => {
    if (!name) return null;

    // standardowy przypadek: props[`${name}_selected`]
    const direct = this.props[`${name}_selected`];
    if (direct !== undefined) return direct ?? null;

    // bramy per typ: name = "gates_swing_color" itd.
    const gateType = GATE_COLOR_TYPE_BY_KEY[name];
    if (gateType) {
      return (this.props.gatesColorSelectedByType && this.props.gatesColorSelectedByType[gateType]) || null;
    }

    return null;
  };

  // DO WYŚWIETLANIA (fallback na pierwszy smooth)
  getSelectedFromProps = (name) => {
    const raw = this.getSelectedFromPropsRaw(name);
    if (raw != null) return raw;

    const defaultSmoothId = this.getDefaultSmoothId();
    return defaultSmoothId ?? null;
  };

  confirm = () => {
    if (this.state.toAll && this.state.selected) {
      this.props.setAllColors(this.state.selected, this.state.isWooden);
    } else if (this.state.selected) {
      this.props.setSelected(this.state.name, this.state.selected);
    }

    this.closeModal();
  }

  handleChange = (value, isWooden) => {
    this.setState({ selected: value, isWooden });
  }

  openModal = (info, name) => {
    const currentOrDefault = this.getSelectedFromProps(name);

    this.setState({
      modalVisible: true,
      info,
      name,
      activeGateType: null,
      toAll: false,
      selected: currentOrDefault,
      isWooden: false
    });
  }

  openGateColorModal = (gateType) => {
    const name = GATE_COLOR_KEY_BY_TYPE[gateType]; // ✅ NOWY KLUCZ
    const currentOrDefault = this.getSelectedFromProps(name);

    this.setState({
      modalVisible: true,
      info: this.props.gates_color_info,
      name,
      activeGateType: gateType,
      toAll: false,
      selected: currentOrDefault,
      isWooden: false
    });
  }

  closeModal = () => {
    this.setState({
      modalVisible: false,
      name: null,
      activeGateType: null
    });

    setTimeout(() => {
      this.setState({
        info: null,
        selected: null,
        isWooden: false
      });
    }, 300);
  }

  renderOption = (info, selected, name, index) => {
    if (selected) {
      const item = this.props.colors.find((c) => c.id === selected);

      return (
        <EditWrapper
          isEdit={false}
          onEditClick={() => { this.openModal(info, name); }}
          noEdit={false}
          key={`${name}-${index}`}
        >
          <Content>
            <StyledTitle>{(this.props.translationsData && this.props.translationsData[name]) || name}:</StyledTitle>
            <SelectedWrapper>
              {
                selected
                  ? this.renderItem(item, info && info.name)
                  : (this.props.translationsData && this.props.translationsData.lack_of) || 'lack_of'
              }
            </SelectedWrapper>
          </Content>
        </EditWrapper>
      );
    }

    return null;
  }

  renderGateColorOption = (gateType, index) => {
    const name = GATE_COLOR_KEY_BY_TYPE[gateType]; // ✅ NOWY KLUCZ

    // do display: fallback na pierwszy smooth
    const selected = this.getSelectedFromProps(name);
    const item = selected ? this.props.colors.find((c) => c.id === selected) : null;

    return (
      <EditWrapper
        isEdit={false}
        onEditClick={() => { this.openGateColorModal(gateType); }}
        noEdit={false}
        key={`${name}-${index}`}
      >
        <Content>
          {/* bez gates_color / gate_color – tylko brama/typ */}
          <StyledTitle>{`${this.getGateTypeLabel(gateType)}:`}</StyledTitle>
          <SelectedWrapper>
            {
              selected && item
                ? this.renderItem(item, this.props.gates_color_info && this.props.gates_color_info.name)
                : (this.props.translationsData && this.props.translationsData.lack_of) || 'lack_of'
            }
          </SelectedWrapper>
        </Content>
      </EditWrapper>
    );
  }

  renderGateColorFallbackSingle = () => {
    const name = 'gates_color';

    const selected = this.getSelectedFromProps(name);
    const item = selected ? this.props.colors.find((c) => c.id === selected) : null;

    return (
      <EditWrapper
        isEdit={false}
        onEditClick={() => { this.openModal(this.props.gates_color_info, name); }}
        noEdit={false}
        key="gates_color_single"
      >
        <Content>
          <StyledTitle>{GATES_LABEL_BASE}:</StyledTitle>
          <SelectedWrapper>
            {
              selected && item
                ? this.renderItem(item, this.props.gates_color_info && this.props.gates_color_info.name)
                : (this.props.translationsData && this.props.translationsData.lack_of) || 'lack_of'
            }
          </SelectedWrapper>
        </Content>
      </EditWrapper>
    );
  }

  renderItem = (item, key, name, isWooden = false) => {
    if (!item) return null;

    const selectedId = this.state.selected !== null
      ? this.state.selected
      : this.getSelectedFromProps(this.state.name);

    const selected = selectedId === item.id;

    const translatedName =
      (this.props.translationsData &&
        this.props.translationsData.inputs &&
        this.props.translationsData.inputs[`colors_28_${item.id}`]) ||
      `inputs.colors_28_${item.id}`;

    return (
      <ItemContainer
        key={`${item.color_name}-${key}`}
        click={!!name}
        onClick={name ? () => { this.handleChange(item.id, isWooden); } : () => {}}
      >
        <ColorContainer>
          <Color
            style={
              item.preview_url
                ? {
                  backgroundColor: item.hexa,
                  backgroundImage: `url(${item.preview_url})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                }
                : {
                  backgroundColor: item.hexa,
                }
            }
          />
        </ColorContainer>
        <ColorName selected={selected && !!this.state.name}>
          {translatedName}
        </ColorName>
      </ItemContainer>
    );
  }

  render() {
    if (!this.props.loaded) return <SelectEdit loading />;

    const visibleGateTypes = this.getVisibleGateTypes();
    const colorsWithoutGates = (colors || []).filter((c) => c !== 'gates_color');

    const isGateKey = !!(this.state.name && GATE_COLOR_TYPE_BY_KEY[this.state.name]);

    const modalTitle = (() => {
      if (!this.state.info) return '';
      if (isGateKey && this.state.activeGateType) {
        return `${this.state.info.name} - ${this.getGateTypeLabel(this.state.activeGateType)}`;
      }
      return this.state.info.name;
    })();

    return (
      <React.Fragment>
        <div style={{ padding: '0 24px', background: colorsVariables.white }}>
          {/* BRAMY - per typ */}
          {visibleGateTypes.length > 0
            ? visibleGateTypes.map(this.renderGateColorOption)
            : this.renderGateColorFallbackSingle()
          }

          {/* RESZTA - jak było */}
          {colorsWithoutGates.map((el, index) => (
            this.renderOption(
              this.props[`${el}_info`],
              this.props[`${el}_selected`],
              el,
              index
            )
          ))}
        </div>

        <SelectEdit
          selected={this.props.sheet_thickness_selected}
          title={this.props.translationsData && this.props.translationsData.focus_on_quality}
          onChange={(id) => { this.props.setSelected('sheet_thickness', id); }}
          options={(this.props.sheet_thickness_available || []).map((el) => (
            {
              id: el.id,
              value: el.attributes.value_mm === 0
                ? (this.props.translationsData && this.props.translationsData.lack_off) || ''
                : (this.props.translationsData && this.props.translationsData.tuv_theinland) || ''
            }
          ))}
          nested
        />

        <Modal
          title={modalTitle}
          destroyOnHidden={true}
          open={this.state.modalVisible}
          footer={[
            <Button key="back" onClick={this.closeModal} style={{ color: colorsVariables.main }}>
              {(this.props.translationsData && this.props.translationsData.cancel) || 'cancel'}
            </Button>,
            <Button key="submit" type="primary" onClick={this.confirm}>
              {(this.props.translationsData && this.props.translationsData.choose) || 'choose'}
            </Button>
          ]}
          onCancel={this.closeModal}
          width={1000}
        >
          <div
            className="ant-alert ant-alert-error ant-alert-no-icon"
            style={{ marginBottom: 20 }}
          >
            <Checkbox
              checked={this.state.toAll}
              onChange={(e) => { this.setState({ toAll: e.target.checked }); }}
            >
              {this.state.toAll}
              {(this.props.translationsData && this.props.translationsData.use_color_for) || 'use_color_for'}:
            </Checkbox>
          </div>

          <ModalContainer>
            <ColorWrapper>
              <Title level={4}>{(this.props.translationsData && this.props.translationsData.matt) || 'matt'}:</Title>
              {this.props.available.matt && this.props.available.matt.map((el, key) => this.renderItem(
                el,
                key,
                this.state.info && this.state.info.name
              ))}
            </ColorWrapper>

            <ColorWrapper>
              <Title level={4}>{(this.props.translationsData && this.props.translationsData.smooth) || 'smooth'}:</Title>
              {this.props.available.smooth && this.props.available.smooth.map((el, key) => this.renderItem(
                el,
                key,
                this.state.info && this.state.info.name
              ))}
            </ColorWrapper>

            {this.state.name && !this.state.name.includes('roof') ? (
              <ColorWrapper>
                <Title level={4}>{(this.props.translationsData && this.props.translationsData.woodlike) || 'woodlike'}:</Title>
                {this.props.available.wooden && this.props.available.wooden.map((el, key) => this.renderItem(
                  el,
                  key,
                  this.state.info && this.state.info.name,
                  true
                ))}
              </ColorWrapper>
            ) : null}
          </ModalContainer>

          <Divider>{this.state.info && this.state.info.info_title}</Divider>
          {this.state.info && this.state.info.info_content}
        </Modal>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = {
  setSelected,
  setAllColors
};

export default connect(selector, mapDispatchToProps)(ColorEditor);
